// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__MjxKA","inputWrap":"CustomTip_inputWrap__9gA1b"};